export enum PagesTestIds {
  MainContent = 'main-content',
  LandingPage = 'landing-page',
  WelcomeView = 'welcome-view',
  OtpView = 'otp-view',
  PinCodeView = 'pin-code-view',
  HealthcareTransitionView = 'healthcare-transition-view',
  CustomerDetailsPage = 'customer-details-page',
  OptionsLoadingPage = 'options-loading-page',
  ChooseYourPlanPage = 'choose-your-plan-page',
  PaymentDetailsPage = 'payment-details-page',
  AgreementPage = 'agreement-page',
  FinalReviewPage = 'final-review-page',
  ProcessingPaymentPage = 'processing-payment-page',
  PostChargeFailedPage = 'post-charge-failed-page',
  ThankYouPage = 'thank-you-page',
  EstimateThankYouPage = 'estimate-thank-you-page',
  ValidateDebitCardPage = 'validate-debit-card-page',
  PurchaseAmountPendingPage = 'purchase-amount-pending-page',
  PurchaseAmountNotConfirmedPage = 'purchase-amount-not-confirmed-page',
  DeclinePage = 'decline-page',
  DeclinePageTitle = 'decline-page-title',
  DeclinePageSubtitle = 'decline-page-subtitle',
  RccMethodView = 'rcc-method-view',
  MlaMethodView = 'mla-method-view',
  ExpiredView = 'expired-view',
  SessionInactivityMessagePage = 'session-inactivity-message-page',
  OtpInput = 'otp-input',
  PincodeMethodSmsRadio = 'pincode-method-sms-radio',
  PincodeMethodCallRadio = 'pincode-method-call-radio',
  SubmitButton = 'submit-button',
  OtpPhoneInput = 'phone-number-input',
  Loader = 'loader',
  VerificationCodeError = 'verification-code-error',
  DemoStoreSunbitMethod = 'sunbit_method',
  DemoStoreCheckoutButton = 'data-checkout-button',
  Email = 'email-verification-popup',
  WVDisclosurePage = 'wv-disclosure-page',
}

export enum PopupTestIds {
  ProvePopup = 'prove-popup',
  EmailVerificationPopup = 'email-verification-popup',
  UpdatePurchaseAmountPopup = 'update-purchase-amount-popup',
  SessionInactivePopup = 'session-inactive-popup',
  PromotionPopup = 'promotion-popup',
  WVDisclosurePopup = 'wv-disclosure-popup',
  DeclinePopup = 'decline-popup',
}

export enum LinksTestIds {
  RatesAndTerms = 'rates-and-terms',
  TermsAndConditions = 'terms-and-conditions',
  PrivacyPolicy = 'privacy-policy',
  ArbitrationProvision = 'arbitration-provision',
  TermsOfUse = 'terms-of-use',
  ESignConsentLink = 'e-sign-consent-link',
  CreditReportAuthorizationLink = 'credit-report-authorization-link',
}
